import '../styles/portal-ri.scss';
import {Chart} from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import * as bootstrap from 'bootstrap';

var container = document.getElementById('graphicDebit');

if(container) {
    Chart.register(ChartDataLabels);
    var labels = container.dataset.label.split(",");
    var values = container.dataset.value.split(",");

    var colors = ['#90acb4'];
    for(i = 0; i < labels.length; i++) {
        if(i) colors.push("#f37a19");
    }

    new Chart(
        document.getElementById('graphicDebitDesktop'),
        {
            type: 'bar',
            data: {
                labels: labels,

                datasets: [{
                    borderRadius: 10,
                    data: values,
                    backgroundColor: colors
                }]
            },
            options: {
                plugins: {
                    legend: {
                        display: false,
                    },

                    tooltip: {
                        enabled: false,
                    },

                    datalabels: {
                        align: 'bottom',
                        anchor: 'end',
                        color: 'white',
                        font: {
                            size: '16px',
                            weight: '700'
                        },
                        formatter: function(value, context) {
                            return Intl.NumberFormat('pt-BR').format(value);
                        }
                    }
                },

                scales: {
                    x: {
                        grid: {
                            display: false
                        },

                        //tricks: {
                        //    autoSkip: false,
                        //    maxRotation: 90,
                        //    minRotation: 90,
                        //    padding: -110
                        //}
                    },

                    y: {
                        display: false,
                        grid: {
                            display: false
                        },
                        beginAtZero: true
                    }
                },
            }
        }
    );

    new Chart(
        document.getElementById('graphicDebitMobile'),
        {
            type: 'bar',
            data: {
                labels: labels,

                datasets: [{
                    borderRadius: 10,
                    data: values,
                    backgroundColor: colors
                }]
            },
            options: {
                indexAxis: 'y',
                plugins: {
                    legend: {
                        display: false,
                    },

                    tooltip: {
                        enabled: false,
                    },

                    datalabels: {
                        align: 'center',
                        anchor: 'center',
                        color: 'white',
                        font: {
                            size: '16px',
                            weight: '700'
                        },
                        formatter: function(value, context) {
                            return Intl.NumberFormat('pt-BR').format(value);
                        }
                    }
                },

                scales: {
                    x: {
                        display: false,
                        grid: {
                            display: false
                        },

                        tricks: {
                            autoSkip: false,
                            maxRotation: 90,
                            minRotation: 90,
                            padding: -110
                        }
                    },

                    y: {
                        grid: {
                            display: false
                        },
                        beginAtZero: true
                    }
                },
            }
        }
    );
}

// jQuery
$(() => {
    // Filtrar por trimestre ou ano
    $('.filter-results').on('change', function(e)
    {
        e.stopPropagation();
        e.preventDefault();

        let container = $(this).parents('.tab-pane');
        let year = container.find('.filter_year').val();
        let quarter = container.find('.filter_quarter').val();
        let target = container.find('.filter_year').data('target');

        console.log(target, $(target));

        $(target).find('[data-trigger="filter"]').css('display', 'none');

        if(quarter && !year) {
            $(target).find('tr[data-quarter="'+ quarter +'"]').css('display', 'table-row');
        }

        else if(year && !quarter) {
            $(target).find('[data-year="'+ year +'"]').css('display', 'table-row');
        }

        else if(quarter && year) {
            $(target).find('[data-year="'+ year +'"][data-quarter="'+ quarter +'"]').css('display', 'table-row');
        }

        else {
            $(target).find('[data-trigger="filter"]').css('display', 'table-row');
        }
    });

    // Filtrar por trimestre ou ano
    $('.filter-fixed').on('change', function(e)
    {
        e.stopPropagation();
        e.preventDefault();

        let table = $('#table-fixed');
        let year = $('#filter_year').val();
        let company = $('#filter_company').val();

        table.find('[data-trigger="filter"]').addClass('sr-only');

        if(company && !year) {
            table.find('[data-company="'+ company +'"]').removeClass('sr-only');
        }

        else if(year && !company) {
            table.find('[data-year="'+ year +'"]').removeClass('sr-only');
        }

        else if(company && year) {
            table.find('[data-year="'+ year +'"][data-company="'+ company +'"]').removeClass('sr-only');
        }

        else {
            table.find('[data-trigger="filter"]').removeClass('sr-only');
        }
    });

    /**
     * -------------------------------------------------------------------------
     * Filtrar eventos
     * -------------------------------------------------------------------------
     */
    $('#table-event .data-row:nth-child(n+11)').addClass('sr-only');
    $('.filter-event').on('change', function(e)
    {
        e.stopPropagation();
        e.preventDefault();

        let table = $('#table-event');
        let year = $('#filter_year').val();

        table.find('.data-row').addClass('sr-only');

        if(year) {
            table.find('[data-year="'+ year +'"]').removeClass('sr-only');
        }

        else {
            table.find('.data-row:nth-child(-n+10)').removeClass('sr-only');
        }
    });

    $(document).on('click', '.btn-event-nav', function(e)
    {
        e.stopPropagation();
        e.preventDefault();

        let btn = $(this);

        $.ajax({
            method: 'GET',
            url: '/wp-ajax/calendar-multiple',
            data: {
                timestamp: btn.data('timestamp'),
                lang: btn.data('lang'),
                post: btn.data('post'),
            },
            success: (data) => {
                $('#multipleCalendar').html(data);
            }
        });
    });

    const calendarModal = document.getElementById('calendarModal');
    if (calendarModal) {
        calendarModal.addEventListener('show.bs.modal', function(e)
        {
            let btn = e.relatedTarget
            let title = btn.getAttribute('data-title');
            let content = btn.getAttribute('data-content');

            let modalTitle = calendarModal.querySelector('.modal-title');
            let modalBody = calendarModal.querySelector('.modal-body');

            modalTitle.textContent = title;
            modalBody.innerHTML = content;
        });
    }
});
